var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import styled from 'styled-components';
import { trStyles, tdStyles } from './shared';
import { get } from '../..';
import { DrawerProvider, getPublicRowStateProps, } from '../utils';
import { CloseButton, CloseButtonSpacer } from '../../tools/components';
import { getBoxShadow } from '../shared';
var StyledTr = styled.tr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), trStyles);
var StyledDrawerTd = styled.td(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", "\n  padding: ", " 10px;\n  position: relative;\n"], ["\n  ", "\n  ", "\n  padding: ", " 10px;\n  position: relative;\n"])), tdStyles, getBoxShadow(true), get.space('md'));
var StyledContentWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: ", " ", ";\n"], ["\n  padding: ", " ", ";\n"])), get.space('md'), get.space('xs'));
var Drawer = function (_a) {
    var prepareRow = _a.tableInstance.prepareRow, row = _a.row, drawer = _a.drawer, closeDrawerAndFocus = _a.closeDrawerAndFocus, isDrawerOpen = _a.isDrawerOpen, drawerTargetRef = _a.drawerTargetRef;
    if (!isDrawerOpen)
        return null;
    var _b = __read(row.subRows, 1), drawerRow = _b[0];
    if (!drawerRow)
        return null;
    prepareRow(drawerRow);
    return (React.createElement(StyledTr, __assign({}, drawerRow.getRowProps()),
        React.createElement(StyledDrawerTd, { colSpan: row.cells.length },
            React.createElement(CloseButtonSpacer, null),
            React.createElement(StyledContentWrapper, null,
                React.createElement(DrawerProvider, { value: __assign(__assign({ row: row }, getPublicRowStateProps(row)), { closeDrawer: closeDrawerAndFocus, targetRef: drawerTargetRef }) }, drawer)),
            React.createElement(CloseButton, { "data-track-elem": "icon", "data-track-name": "Close", "data-track-trigger": "close", onClick: function () {
                    closeDrawerAndFocus();
                } }))));
};
export default Drawer;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Drawer.js.map